//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Standard exams data ------------------
const selector = (state) => state.standardexams;

//  -- Standard exams array selector --------
export const useStandardExams = () => {
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
};

//  -- Standard tests data ------------------
const standardTestsSelector = (state) => state.standardtests || [];

//  -- Standard tests array selector --------
export const useStandardTests = () => {
    const selectedData = useSelector(standardTestsSelector, shallowEqual);
    return selectedData;
};